'use strict'
module.exports = {
  NODE_ENV: '"production"',
  API_URL: '"https://deneigementblapiv2.azurewebsites.net/"',
  RECAPTCHA_SITEKEY: '"6LefT8gZAAAAACo9CJEwIQ4XYIm-OfUIhm49zbaO"'
}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 1